// extracted by mini-css-extract-plugin
export default {"addToCartControl":"KZ-z","giftCard":"LZ-z","btnContainer":"MZ-z","cartButton":"NZ-z","disabled":"OZ-z"};